const apiErrorMappings = {
  name: { 'already exists': 'Vendor sudah terdaftar di sistem' },
  pairing_code: {
    'invalid secret': 'Kode Vendor tidak sesuai',
    "can't process your own secret": "Tidak dapat proses Kode Vendor perusahaan milik sendiri"
  },
  'some vendor already have contract': 'vendor.list.vendorhaveContract'
}

export default apiErrorMappings
